module.exports = __webpack_public_path__ + "img/dance-work-icon5.4696255b.png";